import React from 'react';
import _ from 'underscore';
import { Subtract } from 'utility-types';

import { FilterUpdaterOwnProps, withFilterUpdater } from '~src/spacesPlatform/components/Explorer/helpers/FilterUpdater';
import { SortOrderUpdaterOwnProps, withSortOrderUpdater } from '~src/spacesPlatform/components/Explorer/helpers/SortOrderUpdater';

import { ConnectedSimulationSpace } from './ConnectedSimulationSpace';
import { SimulationSpaceOwnProps } from './SimulationSpace';
import {
  InjectedSimulationSpaceDataFetcherProps,
  SimulationSpaceDataFetcherProps,
  withSimulationSpaceDataFetcher,
} from './SimulationSpaceDataFetcher';
import {
  InjectedSimulationSpaceServiceInjectorProps,
  SimulationSpaceServiceInjectorProps,
  withSimulationSpaceServiceInjector,
} from './SimulationSpaceServiceInjector';

export type SimulationSpaceProviderProps =
  FilterUpdaterOwnProps &
  SortOrderUpdaterOwnProps &
  SimulationSpaceDataFetcherProps &
  SimulationSpaceServiceInjectorProps &
  Subtract<Subtract<SimulationSpaceOwnProps, InjectedSimulationSpaceDataFetcherProps>, InjectedSimulationSpaceServiceInjectorProps>;

export const SimulationSpaceProvider: React.ComponentType<SimulationSpaceProviderProps> = _.compose(
  withFilterUpdater,
  withSortOrderUpdater,
  withSimulationSpaceDataFetcher,
  withSimulationSpaceServiceInjector,
)(ConnectedSimulationSpace);
